export default [{  // 店铺资料
    path: 'shop_info',
    name: 'm_shop',
    component: () => import('@/pages/shop/info')
},{  // 预览店铺
    path: 'shop_view',
    name: 'm_shop_view',
    component: () => import('@/pages/shop/view')
},{  // 装修模板
    path: 'decorate_template',
	name: 'm_decoration',
	props: route => route.query,
    component: () => import('@/pages/shop/decorate_template')
},{  // 成功案例列表
    path: 'success_case_list',
    name: 'm_success_case',
    props: route => route.query,
    component: () => import('@/pages/shop/success_case_list.vue')
}, {  // 成功案例新增
    path: 'success_case_add',
    props: route => route.query,
    component: () => import('@/pages/shop/success_case_add.vue')
}, {  // 成功案例编辑
    path: 'success_case_edit/:id',
    props: route => route.params,
    component: () => import('@/pages/shop/success_case_edit.vue')
}, {  // 成功案例详情
    path: 'success_case_detail/:id',
    props: route => route.params,
    component: () => import('@/pages/shop/success_case_detail.vue')
}];